// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-c41acdcc],\n.price[data-v-c41acdcc],\n.coin[data-v-c41acdcc],\n.wrapper[data-v-c41acdcc] {\n  font-size: inherit;\n}", ""]);
// Exports
module.exports = exports;
